// action
import {
    DELETE_MOU,
   DELETE_MOU_FAIL,
    DELETE_MOU_SUCCESS,
    DELETE_MOU_RESET
} from '../action/deleteMouAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_MOU:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_MOU_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_MOU_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_MOU_RESET:
            return initialState
        default:
            return state
    }
}